import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Divider, FormControlLabel, Radio, RadioGroup, Switch } from "@material-ui/core";
import FormControl from "@material-ui/core/FormControl";
import { disableYaragh, getAllYaragh, setNameForSearchBrandYaragh } from "Stores/actions";
import { read } from "Helpers/LocalStorage";
import BackDropLoading from "Components/BackDropLoading/BackDropLoading";
import { SELECT_BRAND_YARAGH } from "Stores/actionTypes";
import NewBrandDialog from "./components/NewBrandDialog";
import DeleteBrand from "./components/DeleteBrand";
import Translator from "Languages/Utility/Translator";
import { ReactSVG } from "react-svg";
import checkBoxCheckIcon from "Assets/svg/icon/checkBoxCheckIcon.svg";
import checkedBoxIcon from "Assets/svg/icon/checkedBoxIcon.svg";
import EditBrand from "./components/EditBrand";
import { useTranslation } from 'react-i18next';
import Input from "Components/Input/Input";
import * as Icons from 'react-bootstrap-icons'
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import { useTheme } from '@material-ui/core/styles';

function BrandYaragh() {
  const { direction } = useTheme();
  const { t } = useTranslation();
  const { brandYaraghList, selectedBrandYaragh, brandYaraghSearch } = useSelector((state) => ({
    brandYaraghList: state.yaragh.brandYaraghList,
    selectedBrandYaragh: state.yaragh.selectedBrandYaragh,
    brandYaraghSearch: state.yaragh.brandYaraghSearch,
  }));
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [search, setSearch] = useState(false);

  const handleChange = async (value) => {
    dispatch({
      type: SELECT_BRAND_YARAGH,
      selectedBrandYaragh: value,
    });
  };

  const setValue = (name, value) => {
    dispatch(setNameForSearchBrandYaragh(value));
  };

  const onSearch = async (e) => {
    e.preventDefault();
    await onGetAllYaragh();
  }

  const onClearSearch = async (e) => {
    e.preventDefault();
    await onGetAllYaragh(true);
  }

  const switchChange = async (e, item) => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: Number(item.Id),
        Disable: !e.target.checked,
      };
      await dispatch(disableYaragh(data));
      await onGetAllYaragh();
      setLoading(false);
    } catch (e) {
      setLoading(false);
    }
  };

  const onGetAllYaragh = async (clear = false, selectedIndex = -1) => {
    try {
      if(brandYaraghList && selectedBrandYaragh) {
        setLoading(true);
        let dataSearch = null;
        if(!clear && brandYaraghSearch && brandYaraghSearch !== "") dataSearch = { Name: brandYaraghSearch } 
        if(clear) dispatch(setNameForSearchBrandYaragh(""));
        const params = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          ...dataSearch
        };
        await dispatch(getAllYaragh(params, selectedIndex));
      }
    } catch (err) {
      console.error('[catch error]', err)
    }
    setLoading(false);
  }

  return (
    <>
      <BackDropLoading loading={loading} />
      <div className="side-box">
        <div>
          <MuiIconButton
            title={<Translator id={"searchBrandFitting"} />}
            icon={<Icons.Search size={17}/>}
            onClick={() => setSearch(!search)}
            className={`fix-size ${search ? "standby" : ''}`}
            disabled={!(brandYaraghList && selectedBrandYaragh)}
          />
          <Translator id={"brandFitting"} />
        </div>
        <div>
          {
            selectedBrandYaragh &&
            <>
              <NewBrandDialog reGetOnBack={onGetAllYaragh} />
              <EditBrand reGetOnBack={onGetAllYaragh} />
              <DeleteBrand reGetOnBack={onGetAllYaragh} />
            </>
          }
        </div>
      </div>
      <div className={`search-box-sidebox ${search ? 'show-mode' : 'hide-mode' }`}>
        <Input
          setValue={setValue.bind(this)}
          name="search"
          value={brandYaraghSearch}
          placeholder={t('searchBrandFitting')}
          type="search"
          onSearch={onSearch}
          onClearSearch={onClearSearch}
        />
      </div>
      {brandYaraghList && selectedBrandYaragh && (
        <FormControl component="fieldset" className="radioGroup sideBoxSm">
          <RadioGroup>
            {brandYaraghList.map((item) => {
              return (
                <div className="d-flex justify-content-between" key={item.Id}>
                  <FormControlLabel
                    value={item.Id}
                    key={item.Id}
                    className={ direction === 'rtl' ? "text-right" : "text-left" }
                    control={
                      <Radio
                        // size="small"
                        checked={selectedBrandYaragh.Id === item.Id}
                        onChange={() => handleChange(item)}
                        className="mx-2"
                        // checkedIcon={<ReactSVG src={checkBoxCheckIcon} />}
                        // icon={<ReactSVG src={checkedBoxIcon} />}
                      />
                    }
                    label={item.Name}
                  />
                  <Switch
                    className={`switcher ${direction}`}
                    color="primary"
                    checked={!item.Disable}
                    onChange={(e) => switchChange(e, item)}
                  />
                </div>
              );
            })}
          </RadioGroup>
        </FormControl>
      )}
    </>
  );
}

export default BrandYaragh;
